import { Website, WebsiteConfiguration } from '../../types/Website';
import { WebsiteState, WebsiteType } from '../../types/website.types';

// TODO: this doens't look right. compare to the other
export const fetchWebsite = async (websiteId: string): Promise<Website> => {
  const mockWebsiteConfig: WebsiteConfiguration = {
    dataSources: [],
    assets: [],
    styles: [
      {
        selectors: ['my-el'],
        style: {
          color: 'red',
        },
      },
      {
        selectors: ['my-el'],
        style: {
          color: 'blue',
        },
      },
      {
        selectors: ['#ivnj'],
        style: {},
      },
    ],
    pages: [
      {
        id: 'my-first-page',
        name: '',
        html: '<!DOCTYPE html>\n<html>\n<head>\n<meta charset="utf-8">\n<meta name="viewport" content="width=device-width, initial-scale=1">\n<title>{TITLE_PLACEHOLDER}</title>\n<style>* { box-sizing: border-box; } body {margin: 0;}</style>\n</head>\n<body><h2 id="ivnj">dsasdsds<br/><br/>br</h2></body>\n</html>',
      },
      {
        id: 'my-second-page',
        name: '',
        html: '<!DOCTYPE html>\n<html>\n<head>\n<meta charset="utf-8">\n<meta name="viewport" content="width=device-width, initial-scale=1">\n<title>{TITLE_PLACEHOLDER}</title>\n<style>* { box-sizing: border-box; } body {margin: 0;}</style>\n</head>\n<body><h2>Hello world 2!</h2></body>\n</html>',
      },
    ],
    symbols: [],
    totalPages: 2,
  };

  // Mock data
  return new Website({
    id: '1',
    organizationId: '1',
    title: 'Website 1',
    subdomain: 'website1',
    searchEngineVisibility: true,
    lastPublishedAt: new Date(),
    draft: mockWebsiteConfig,
    published: mockWebsiteConfig,
  });
};

export const getWebsiteLookupDataFromUrl = (searchParams: URLSearchParams) => {
  const websiteId = searchParams.get('websiteId');
  const websiteState: WebsiteState = searchParams.get('state') as WebsiteState;
  const websiteType: WebsiteType = searchParams.get('type') as WebsiteType;

  return {
    websiteId,
    websiteState,
    websiteType,
  };
};
